@if (!isInline()) {
  <div class="modal-backdrop fade show" (click)="closed.emit()"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content fm-create-family-modal">
        <ng-container [ngTemplateOutlet]="formTpl"></ng-container>
      </div>
    </div>
  </div>
} @else {
  <div class="fm-inline-panel">
    <ng-container [ngTemplateOutlet]="formTpl"></ng-container>
  </div>
}

<ng-template #formTpl>
  <div class="fm-modal-header" [class.modal-header]="!isInline()">
    <h5 class="fm-head-20" [class.modal-title]="!isInline()">{{ editFamily() ? 'Edit Family' : 'Create New Family' }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closed.emit()"></button>
  </div>

  <form [formGroup]="familyForm" (ngSubmit)="onSubmit()" novalidate class="fm-create-family-form">

    <div class="fm-modal-body" [class.modal-body]="!isInline()">
      <div class="row g-3">

        <!-- Family Logo (optional) -->
        <div class="col-12">
          <div class="fm-optional-fileupload">
            <label class="fm-label mb-2">Family Logo <span class="fm-optional-tag">(Optional)</span></label>
            @if (!logoPreview()) {
              <label class="fm-fileupload fm-fileupload-dashed">
                <div class="fm-upload-content text-center">
                  @if (isLogoUploading()) {
                    <span class="spinner-border spinner-border-sm" role="status"></span>
                    <p class="mb-0">Uploading…</p>
                  } @else {
                    <img src="images/icons/fm-upload-icon.svg" class="fm-svg mb-2" alt="Upload" />
                    <p class="mb-0">Drop your photo here, or <span class="fm-browse-link">Browse</span></p>
                    <p class="mb-0 fm-upload-formats">Supported formats: JPG, JPEG, PNG, GIF, WebP, SVG</p>
                  }
                </div>
                <input
                  type="file"
                  accept="image/*"
                  class="d-none"
                  (change)="onLogoSelected($event)"
                  [disabled]="isLogoUploading()"
                />
              </label>
            } @else {
              <div class="fm-img-preview-block">
                <div class="fm-img-preview-thumb-wrap">
                  <img [src]="logoPreview()" class="fm-img-preview-thumb" alt="Family Logo Preview" />
                  @if (isLogoUploading()) {
                    <div class="fm-img-uploading-overlay">
                      <span class="spinner-border spinner-border-sm" role="status"></span>
                    </div>
                  }
                  <button
                    type="button"
                    class="fm-img-remove-corner"
                    (click)="removeLogo()"
                    [disabled]="isLogoUploading()"
                    aria-label="Remove logo"
                  >
                    <i class="bi bi-x"></i>
                  </button>
                </div>
              </div>
            }
          </div>
        </div>

        <!-- Family Name -->
        <div class="col-12">
          <div class="form-group">
            <label class="fm-label">Family Name <span class="fm-required">*</span></label>
            <input
              type="text"
              class="form-control"
              formControlName="familyName"
              appTrimWhitespace
              placeholder="Enter your family name"
              maxlength="50"
              [class.is-invalid]="f['familyName'].invalid && f['familyName'].touched"
            />
            @if (f['familyName'].errors?.['required'] && f['familyName'].touched) {
              <div class="invalid-feedback">Family name is required.</div>
            }
            @if (f['familyName'].errors?.['minlength'] && f['familyName'].touched) {
              <div class="invalid-feedback">Must be at least 2 characters.</div>
            }
            @if (f['familyName'].errors?.['maxlength'] && f['familyName'].touched) {
              <div class="invalid-feedback">Cannot exceed 50 characters.</div>
            }
            <p class="fm-light mt-2 mb-0">This is what your family members will see when they're invited</p>
          </div>
        </div>

        <!-- Welcome Message -->
        <div class="col-12">
          <div class="form-group">
            <label class="fm-label">Welcome Message <span class="fm-optional-tag">(Optional)</span></label>
            <textarea
              class="form-control"
              formControlName="welcomeMessage"
              rows="3"
              placeholder="Write something here...."
              maxlength="300"
              [class.is-invalid]="f['welcomeMessage'].errors?.['maxlength'] && f['welcomeMessage'].touched"
            ></textarea>
            @if (f['welcomeMessage'].errors?.['maxlength'] && f['welcomeMessage'].touched) {
              <div class="invalid-feedback">Cannot exceed 300 characters.</div>
            }
          </div>
        </div>

      </div>
    </div>

    <div class="fm-modal-footer">
      <button type="button" class="fm-common-btn fm-border-btn" (click)="closed.emit()">
        Cancel
      </button>
      <button type="submit" class="fm-common-btn" [disabled]="isLoading() || isLogoUploading()">
        @if (isLoading()) {
          <span class="spinner-border spinner-border-sm me-2" role="status"></span>
          {{ editFamily() ? 'Updating...' : 'Creating...' }}
        } @else {
          {{ editFamily() ? 'Update Family' : 'Create Family' }}
        }
      </button>
    </div>

  </form>
</ng-template>
